import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { context } from "../../../context/context";

const { forwardRef, useRef, useImperativeHandle } = React;

const PermissionSelect = forwardRef(
  ({ oldPermissions, onChange, label }, ref) => {
    const { utils } = useContext(context);

    const [permissionsOption, setPermissionsOption] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);

    useImperativeHandle(ref, () => ({
      afterSubmit() {
        setSelectedPermissions([]);
      },
    }));

    useEffect(() => {
      if (utils?.PERMISSIONS_RESURCES_VALUES?.length) {
        let newPermission = utils?.PERMISSIONS_RESURCES_VALUES?.map((item) => {
          return {
            value: item.value,
            label: item.name,
          };
        });
        setPermissionsOption(newPermission);
      }
    }, [utils]);

    function handlePermissions(data) {
      setSelectedPermissions(data);
      const newData = data.map((item) => {
        return item.value;
      });
      onChange(newData || []);
    }

    useEffect(() => {
      if (
        oldPermissions?.length > 0 &&
        utils?.PERMISSIONS_RESURCES_VALUES?.length
      ) {
        let selectedPermissions = [];
        for (let i = 0; i < oldPermissions?.length; i++) {
          let isExist = utils?.PERMISSIONS_RESURCES_VALUES.filter((item) => {
            return item.value == oldPermissions[i].resource;
          });
          selectedPermissions.push({
            value: isExist[0]?.value,
            label: isExist[0]?.name,
          });
          console.log(isExist);
        }
        console.log(selectedPermissions);
        setSelectedPermissions(selectedPermissions);
      }
    }, [oldPermissions, utils]);

    return (
      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {label}
        </label>
        <Select
          className=""
          options={permissionsOption}
          placeholder="انتخاب دسترسی"
          value={selectedPermissions}
          onChange={handlePermissions}
          isSearchable={true}
          isMulti
        />
      </div>
    );
  }
);

export default PermissionSelect;
